<template>
  <section>
    <header>
      <div class="topStyle">
        <p @click="toHome">
          <img src="../assets/images/indexlogo.png" />
        </p>
        <el-row class="formStyle">
          <el-col :span="16" :offset="4">
            <el-input placeholder="请输入企业全称查询" v-model.trim="keyWord" clearable>
              <el-button slot="append" @click="SubmitSearch('search')">查询</el-button>
            </el-input>
          </el-col>
        </el-row>
      </div>
      <hr />
    </header>
    <main>
      <h3>
        <i></i>&nbsp;&nbsp;&nbsp;企业资质资格
      </h3>
      <el-table :data="companyCAlist" style="width: 100%;margin-bottom:80px;">
        <el-table-column label="企业名称" width="300">
          <template>
            <span
              :title="corporateInfo.corporateName"
              class="textEllipsis"
            >{{corporateInfo.corporateName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="creditName" label="证书名称"></el-table-column>
        <el-table-column prop="creditCode" label="证书编号"></el-table-column>
        <el-table-column prop="creditType" label="证书类别"></el-table-column>
        <el-table-column prop="creditLevel" label="资质等级"></el-table-column>
        <el-table-column prop="validDateTxt" label="有效期限"></el-table-column>
      </el-table>
      <hr />
      <h3>
        <i></i>&nbsp;&nbsp;&nbsp;从业人员资格
      </h3>
      <el-table
        :data="personCAlist.slice((currentPage-1)*pageSize,currentPage*pageSize)"
        style="width: 100%;"
      >
        <el-table-column prop="userName" label="姓名" width="180"></el-table-column>
        <el-table-column label="企业名称">
          <template>
            <span>{{corporateInfo.corporateName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="creditCode" label="证书编号"></el-table-column>
        <el-table-column prop="creditName" label="证书名称"></el-table-column>
        <el-table-column prop="creditLevel" label="证书等级"></el-table-column>
        <el-table-column prop="validDateTxt" label="有效期"></el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :page-sizes="[10, 20, 30, 40]"
        layout="prev, pager, next, jumper,sizes,total"
        :total="personCAlist.length"
        style="float:right;margin:15px 0 0;"
        v-if="personCAlist.length>0"
      ></el-pagination>
      <div style="clear:both;"></div>
      <hr style="margin-top:80px;" />
    </main>
    <footer>Copyright&copy;中国系统集成行业协会版权所有</footer>
  </section>
</template>
<script>
const axios = require("axios");
export default {
  name: "searchResult",
  data() {
    return {
      keyWord: "",
      companyCAlist: [],
      personCAlist: [],
      corporateInfo: {},
      currentPage: 1,
      pageSize: 10
    };
  },
  methods: {
    getMsg(value) {
      var companyName = ""
      if (value) {
        companyName = value
      } else {
        companyName = this.$route.query.name
      }
      axios({
        method: "get",
        url: process.env.VUE_APP_BASE_URL + "/auth/query-corporateCredit",
        params: {
          searchText: companyName
        }
      }).then(response => {
        if (response.data.status == 0) {
          console.log(response);
          this.companyCAlist = response.data.data.corporateCredits
          this.personCAlist = response.data.data.personCredits
          this.corporateInfo = response.data.data.corporateInfo
        } else {
          this.$message.error(response.data.message)
        }
      });
    },
    SubmitSearch(msg) {
      if (msg === "search") {
        this.getMsg(this.keyWord);
      }

    },
    toHome() {
      this.$router.push("/");
    },
    handleSizeChange(val) {
      this.pageSize = val;
      // this.getMsg();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      // this.getMsg();
    }
  },
  mounted() {
    if (this.$route.query.name) {
      this.keyWord = this.$route.query.name;
      this.getMsg();
    }
  }
};
</script>
<style scoped>
header,
main,
footer {
  width: 80%;
  margin: 0 auto;
}
header .topStyle {
  overflow: hidden;
  margin: 20px auto;
}
header .topStyle p {
  float: left;
  cursor: pointer;
  font-size: 30px;
}
header .topStyle .formStyle {
  width: 500px;
  height: 40px;
  margin-right: 0px;
  margin-top: 16px;
  float: right;
}
main h3 {
  font-size: 18px;
  color: #333333;
  line-height: 30px;
}
main h3 i {
  display: inline-block;
  border: 1px solid #00477b;
  width: 6px;
  height: 24px;
  border-radius: 3px;
  background: #00477b;
  vertical-align: middle;
  margin-bottom: 2px;
}
main p {
  margin: 30px auto 60px;
  text-align: center;
}
main hr,
header hr {
  background-color: #cccccc;
  height: 1px;
  border: none;
}
footer {
  min-width: 800px;
  height: 160px;
  line-height: 160px;
  text-align: center;
  color: #4d4d4d;
}
</style>